import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OnTapAdvancedService } from 'app/services/dal/on-tap-advanced.service';
import { OnTapBasicService } from 'app/services/dal/on-tap-basic.service';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import * as TapActions from './actions'
import { ToastService } from 'app/services/toast.service';
import { shouldLoadData, trackLoading } from '../effect-helpers';
import * as fromOnTapAdvanced from './reducer';
import { OntaptvPendingConnectionsService } from 'app/services/dal/ontaptv-pending-connections.service';



@Injectable()
export class Effects {

  constructor(
    private actions$: Actions,
    private store: Store,
    private toastService: ToastService,
    private onTapTvPendingConnectionService: OntaptvPendingConnectionsService) { }


  softUpdate$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(TapActions.updateConnectionStatus),
        mergeMap((action) => from(this.onTapTvPendingConnectionService.updateConnectionStatus(
          action.id, 'connected', action.barId))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return TapActions.updateConnectionStatusSuccess()
            }),
            catchError((error) => {
              return of(TapActions.updateConnectionStatusFailure({ error }))
            })
          )
        )
      );
  });


}
